import React from 'react';
import PropTypes from 'prop-types';
// styles
import styled from 'styled-components';

const Row = styled.div`
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 8px;
  gap: 4px;

  /* width: 464px; */
  height: 32px;

  /* grey / 300 */

  border-bottom: 1px solid #ccd6e0;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  box-sizing: border-box;

  /* Auto layout */

  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding: 0px 0px 8px;
  gap: 4px;

  /* width: 464px; */
  height: 32px;

  /* grey / 300 */

  border-bottom: 1px solid #ccd6e0;

  /* Inside auto layout */

  flex: none;
  order: 0;
  align-self: stretch;
  flex-grow: 0;
  &:last-child {
    border: none;
  }
`;

const LeftColumn = styled.div`
  width: 400px;
  height: 24px;

  /* 16px/medium */

  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 700 */

  color: #54708c;
`;

const RightColumn = styled.div`
  /* #time-window-PU */

  /* width: 300px; */
  height: 24px;

  /* 16px/regular

Shipper App Default
*/
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  /* grey / 700 */

  color: #54708c;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 1;
`;

const CustomReferencesTable = ({ className, data }) => {
  return (
    <div className={className}>
      <Row>
        <LeftColumn>Booking:</LeftColumn>
        <RightColumn>{data.booking_number}</RightColumn>
      </Row>
      <Row>
        <LeftColumn>Expediente OL:</LeftColumn>
        <RightColumn>{data.logistics_operator_code}</RightColumn>
      </Row>
      <Row>
        <LeftColumn>Ref. Emisor entrega:</LeftColumn>
        <RightColumn>{data.release_container_provider_reference}</RightColumn>
      </Row>
    </div>
  );
};

CustomReferencesTable.propTypes = {
  className: PropTypes.string,
};

export default styled(CustomReferencesTable)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 12px 16px 4px;
  gap: 8px;

  width: 100%;
  height: 128px;

  /* grey / 100 */

  background: #f2f5f8;
  border-radius: 4px;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
`;
